
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nexum",
      function () {
        return require("private-next-pages/nexum/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nexum"])
      });
    }
  